import { AlertDialog } from 'ui/dialog/alert/alert-dialog';

import { isFeatureAvailable } from 'cadenza/features';
import type { CuratedMapViewId } from 'cadenza/repository/model/curated-map-view-id.gen';
import { getStore } from 'cadenza/store/cadenza-store';
import {
  getCuratedMapViews,
  getOnlyCuratedMapView,
  isDefaultCuratedMapDefined,
  noDefaultMapIsAvailable,
} from 'cadenza/workbook/state/default-map.state';

import i18n from './default-map-utils.properties';

interface DefaultMapConfig {
  baseMapViewId?: CuratedMapViewId;
  canceled: boolean;
}

export async function getBaseMapViewConfigOrSelectInDialog(): Promise<DefaultMapConfig> {
  if (noDefaultMapIsAvailable(getStore().getState())) {
    await showNoDefaultMapViewAvailableError();
    return { canceled: true };
  }
  if (isDefaultCuratedMapDefined(getStore().getState())) {
    return { canceled: false };
  }
  const baseMapViewId = await getOnlyCuratedMapViewOrSelectInDialog();
  const canceled = baseMapViewId === undefined;
  return { baseMapViewId, canceled };
}

export async function showNoDefaultMapViewAvailableError() {
  const messageType = isFeatureAvailable('SET_DEFAULT_MAP') ? 'setDefaultMap' : 'contactAdmin';
  return new AlertDialog(i18n('noMapFound.title'), {
    type: 'error',
    message: i18n(`noMapFound.<${messageType}>.message`),
  }).connectAndShow();
}

async function getOnlyCuratedMapViewOrSelectInDialog() {
  return getOnlyCuratedMapView(getStore().getState())?.itemId ?? (await selectDefaultMapInDialog());
}

async function selectDefaultMapInDialog() {
  const { selectCuratedMapViewInDialog } = await import(
    'cadenza/workbook/curated-map-views/load-curated-map-view-dialog/select-curated-map-view-dialog'
  );
  const curatedMapViews = getCuratedMapViews(getStore().getState());
  return selectCuratedMapViewInDialog(curatedMapViews);
}
